module.exports = __webpack_public_path__ + "static/flags/DE-e01c9710872af8f20516dfe48e0b26b4.gif";